import {
    Briefcase,
    Clipboard,
    DollarSign,
    FileText,
    Folder,
    MapPin,
    Monitor,
    UserPlus,
} from 'react-feather';
import SidebarGroup from '../../components/infrastructure/SidebarGroup';
import SidebarSingle from '../../components/infrastructure/SidebarSingle';
import SidebarTopText from '../../components/infrastructure/SidebarTopText';

const SidebarLinks = ({ sidebarOpen, sidebarExpanded, setSidebarExpanded }) => {
    return (
        <ul className="mt-3">
            {/* Dashboard */}
            <SidebarTopText text="Application" sidebarOpen={sidebarOpen} />
            <SidebarSingle
                allowedRoles={['admin', 'sub_admin']}
                activePath="/"
                name="Dashboard"
                Icon={<Monitor />}
                sidebarOpen={sidebarOpen}
            />
            <SidebarSingle
                allowedRoles={['admin', 'sub_admin']}
                activePath="/interestCalculation"
                name="Interest Calculation"
                Icon={<FileText />}
                sidebarOpen={sidebarOpen}
            />
            <SidebarSingle
                allowedRoles={['admin', 'sub_admin']}
                activePath="/itemsInventory"
                name="Items Inventory"
                Icon={<FileText />}
                sidebarOpen={sidebarOpen}
            />
            <SidebarGroup
                links={[
                    {
                        label: 'Add User',
                        link: '/addUser',
                        allowedRoles: ['admin'],
                    },
                    {
                        label: 'Edit User',
                        link: '/editUser',
                        allowedRoles: ['admin'],
                    },
                    {
                        label: 'View User',
                        link: '/viewUser',
                        allowedRoles: ['admin'],
                    },
                    // {
                    //     label: 'Add Organization',
                    //     link: '/addOrganization',
                    //     allowedRoles: ['admin'],
                    // },
                    // {
                    //     label: 'View Organization',
                    //     link: '/viewOrganization',
                    //     allowedRoles: ['admin'],
                    // },
                ]}
                heading="User"
                Icon={<UserPlus />}
                sidebarExpanded={sidebarExpanded}
                setSidebarExpanded={setSidebarExpanded}
            />
            <SidebarGroup
                links={[
                    // {
                    //     label: 'Yarn Grade',
                    //     link: '/yarnGrade',
                    //     allowedRoles: ['admin','sub_admin'],
                    // },
                    // {
                    //     label: 'Reminder Subject',
                    //     link: '/reminderSubject',
                    //     allowedRoles: ['admin','sub_admin'],
                    // },
                    {
                        label: 'Quality',
                        link: '/createQuality',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                    // {
                    //     label: 'Payment Term',
                    //     link: '/createPaymentTerm',
                    //     allowedRoles: ['admin','sub_admin'],
                    // },
                    // {
                    //     label: 'View Qualities',
                    //     link: '/ViewQualities',
                    //     allowedRoles: ['admin','sub_admin'],
                    // },
                    // {
                    //     label: 'Fetch All Vendors',
                    //     link: '/fetch-all-vendors',
                    //     allowedRoles: ['admin','sub_admin'],
                    // },
                ]}
                heading="Master"
                Icon={<Folder />}
                sidebarExpanded={sidebarExpanded}
                setSidebarExpanded={setSidebarExpanded}
            />
            {/* <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/view-purchase-order"
                name="View Purchase Order"
            /> */}
            <SidebarGroup
                links={[
                    {
                        label: 'View Purchase Order',
                        link: '/view-purchase-order',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                    {
                        label: 'View Received Purchase Order',
                        link: '/view-received-purchase-order',
                        allowedRoles: ['admin'],
                    },
                    {
                        label: 'View Grey Receive',
                        link: '/view-grey-receive',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                ]}
                heading="Grey"
                Icon={<Folder />}
                sidebarExpanded={sidebarExpanded}
                setSidebarExpanded={setSidebarExpanded}
            />
            {/* <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/view-purchase-order"
                name="View Grey Purchase Order"
            /> */}
            {/* <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/mill-dispatch"
                name="Mill Dispatch"
            />
            <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/view-mill-dispatch"
                name="View Mill Dispatch"
            /> */}
            {/* <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="create-gp"
                name="Mill Receive"
            /> */}
            <SidebarGroup
                links={[
                    {
                        label: 'Mill Dispatch',
                        link: '/mill-dispatch',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                    {
                        label: 'View Mill Dispatch',
                        link: '/view-mill-dispatch',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                    {
                        label: 'Mill Receive',
                        link: '/create-gp',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                    {
                        label: 'View Mill Receive',
                        link: '/view-mill-receive',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                ]}
                heading="Mill"
                Icon={<Folder />}
                sidebarExpanded={sidebarExpanded}
                setSidebarExpanded={setSidebarExpanded}
            />
            <SidebarGroup
                links={[
                    {
                        label: 'Create Job Work',
                        link: '/create-job-work',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                    {
                        label: 'View Job Work',
                        link: '/view-job-work',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                ]}
                heading="Job Work"
                Icon={<Folder />}
                sidebarExpanded={sidebarExpanded}
                setSidebarExpanded={setSidebarExpanded}
            />
            <SidebarGroup
                links={[
                    {
                        label: 'Create Write Off Second',
                        link: '/create-writeOff-second',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                    {
                        label: 'View Write Off Second',
                        link: '/view-writeOffSecond',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                ]}
                heading="Write Off Second"
                Icon={<Folder />}
                sidebarExpanded={sidebarExpanded}
                setSidebarExpanded={setSidebarExpanded}
            />
            {/* <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="create-cutting-card"
                name="Create Cutting Card"
            /> */}
            <SidebarGroup
                links={[
                    {
                        label: 'Create Cutting Card',
                        link: '/create-cutting-card',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                    {
                        label: 'View Cutting Card',
                        link: '/view-cutting-card',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                ]}
                heading="Cutting Card"
                Icon={<FileText />}
                sidebarExpanded={sidebarExpanded}
                setSidebarExpanded={setSidebarExpanded}
            />{' '}
            <SidebarGroup
                links={[
                    {
                        label: 'Add Location',
                        link: '/addLocation',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                    {
                        label: 'View Location',
                        link: '/viewLocation',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                    {
                        label: 'Assign Location',
                        link: '/assignLocation',
                        allowedRoles: ['admin', 'sub_admin'],
                    },
                ]}
                heading="Locations"
                Icon={<MapPin />}
                sidebarExpanded={sidebarExpanded}
                setSidebarExpanded={setSidebarExpanded}
            />{' '}
            <SidebarSingle
                allowedRoles={['admin', 'sub_admin']}
                activePath="/mediaLibrary"
                name="Media Library"
                Icon={<Briefcase />}
                sidebarOpen={sidebarOpen}
            />
            {/* <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/view-vendors"
                name="View Vendors"
            />
            <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/view-customer"
                name="View Customers"
            />
            <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/customer-preference"
                name="Customer preference"
            />
            <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/follow-up"
                name="Follow Up"
            />
            <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/pendingOrderList"
                name="Pending Order List"
            />
         
            <SidebarSingle
                Icon={<Clipboard />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/create-purchase-order"
                name="Purchase Order"
            />
           
            <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/view-previous-order"
                name="View Previous Order"
            />
            <SidebarGroup
                links={[
                    {
                        label: 'Yarn Grade',
                        link: '/yarnGrade',
                        allowedRoles: ['admin','sub_admin'],
                    },
                    {
                        label: 'Reminder Subject',
                        link: '/reminderSubject',
                        allowedRoles: ['admin','sub_admin'],
                    },
                    {
                        label: 'Quality',
                        link: '/createQuality',
                        allowedRoles: ['admin','sub_admin'],
                    },
                    {
                        label: 'Payment Term',
                        link: '/createPaymentTerm',
                        allowedRoles: ['admin','sub_admin'],
                    },
                    {
                        label: 'View Qualities',
                        link: '/ViewQualities',
                        allowedRoles: ['admin','sub_admin'],
                    },
                    {
                        label: 'Fetch All Vendors',
                        link: '/fetch-all-vendors',
                        allowedRoles: ['admin','sub_admin'],
                    },
                ]}
                heading="Master"
                Icon={<Folder />}
                sidebarExpanded={sidebarExpanded}
                setSidebarExpanded={setSidebarExpanded}
            />
            <SidebarGroup
                links={[
                    {
                        label: 'Attributes',
                        link: '/AddAttribute',
                        allowedRoles: ['admin','sub_admin'],
                    },
                ]}
                heading="Attributes"
                Icon={<Folder />}
                sidebarExpanded={sidebarExpanded}
                setSidebarExpanded={setSidebarExpanded}
            />
            <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/podelivery"
                name="Create Complain"
            />
            <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/view-complain"
                name="Complaint Summary"
            />
            <SidebarGroup
                links={[
                    {
                        label: ' Trigger Automation',
                        link: '/trigger-automation',
                        allowedRoles: ['admin','sub_admin'],
                    },
                    {
                        label: 'Create Invoice',
                        link: '/create-invoice',
                        allowedRoles: ['admin','sub_admin'],
                    },
                    {
                        label: 'View Invoices',
                        link: '/view-invoice',
                        allowedRoles: ['admin','sub_admin'],
                    },
                ]}
                heading="Invoice"
                Icon={<DollarSign />}
                sidebarExpanded={sidebarExpanded}
                setSidebarExpanded={setSidebarExpanded}
            />

            <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/ultraDiagnosis"
                name="Diagnosis Projects"
            />
            <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/report"
                name="Report"
            />
            <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/viewNotice"
                name="Notice"
            />
            <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/view-notification"
                name="Notifications"
            />
            <SidebarSingle
                Icon={<FileText />}
                allowedRoles={['admin','sub_admin']}
                sidebarOpen={sidebarOpen}
                activePath="/view-sucess-notification"
                name="Success Notifications"
            /> */}
        </ul>
    );
};

export default SidebarLinks;
